import { render, staticRenderFns } from "./YBMember.vue?vue&type=template&id=53776f77&scoped=true&"
import script from "./YBMember.vue?vue&type=script&lang=js&"
export * from "./YBMember.vue?vue&type=script&lang=js&"
import style0 from "./YBMember.vue?vue&type=style&index=0&id=53776f77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53776f77",
  null
  
)

export default component.exports